
import { Badge } from "@/components/ui/badge";
import { SubscriptionFeatures } from "@/lib/types";

interface PlanFeaturesBadgesProps {
  features: SubscriptionFeatures;
}

export function PlanFeaturesBadges({ features }: PlanFeaturesBadgesProps) {
  return (
    <div className="flex flex-wrap gap-1">
      {features.currency_conversion && (
        <Badge variant="secondary" className="text-xs">Currency Conversion</Badge>
      )}
      {features.multiple_currencies && (
        <Badge variant="secondary" className="text-xs">Multiple Currencies</Badge>
      )}
      {features.price_comparison && (
        <Badge variant="secondary" className="text-xs">Price Comparison</Badge>
      )}
      {features.grouped_contracts && (
        <Badge variant="secondary" className="text-xs">Grouped Contracts</Badge>
      )}
      {features.contract_services && (
        <Badge variant="secondary" className="text-xs">Contract Services</Badge>
      )}
      {features.reminders && (
        <Badge variant="secondary" className="text-xs">Reminders</Badge>
      )}
      {features.payment_type_selection && (
        <Badge variant="secondary" className="text-xs">Payment Types</Badge>
      )}
      {features.dashboard && (
        <Badge variant="secondary" className="text-xs">Dashboard</Badge>
      )}
    </div>
  );
}
